import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  getGridTranslations,
  getTranslations,
} from "../../../../translations/Translations";
import { useRevalidator, useRouteLoaderData } from "react-router-dom";
import {
  ContactsRouterResponse,
  INewRecord,
  IRecord,
} from "../../../../interfaces/Interfaces";
import {
  DataGrid,
  GridActionsCellItem,
  GridActionsColDef,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import ContactImportControl from "./ContactImportControl";
import { useFormik } from "formik";
import Registrationfield from "../../../../components/Registrationfield";
import SaveBar from "../../../../components/SaveBar";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import { ActivityGroup, InitialValues, SessionRecord, ValidationConfig, ValidationTypes } from "../../../templates/Interfaces";
import { buildYupStringSchema } from "../../../templates/Helpers";

interface ImportedContactsProps {
  routeLoader: string;
  registered: boolean;
}

function ImportedContacts() {
  const props: ImportedContactsProps = {
    registered: false,
    routeLoader: "importedcontacts",
  };

  const translations = getTranslations();
  const gridtranslations = getGridTranslations();
  const {
    registrations,
    registrationsCount,
    fields,
    eventId,
    registrationWidgetId,
    sessions, 
    blocks
  } = useRouteLoaderData(props.routeLoader) as ContactsRouterResponse;
  const revalidator = useRevalidator();
  const [open, setOpen] = useState<boolean>(false);
  const [confirmtitle, setConfirmtitle] = useState<string>("");
  const [confirmmessage, setConfirmmessage] = useState<string>("");
  const [confirmFunction, setConfirmFunction] = useState<Function>(
    () => () => { }
  );
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [rowCountState, setRowCountState] =
    useState<number>(registrationsCount);
  const [id, setId] = useState<number>(-1);
  const [myDialogTitle, setMyDialogTitle] = useState<string>(
    translations["contacts.newcontacttitle"]
  );
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });
  const [rows, setRows] = useState<IRecord[]>(
    registrations.map((reg) => {
      return {
        id: reg.id,
        ...reg.values,
      };
    })
  );

    const tabHasError = (tabIndex: number) => {
  if (tabIndex === 0) {
    return Object.entries(formik.errors).some(([key, value]) => key.startsWith('field') && formik.touched[key]);
  } else if (tabIndex === 1) {
     return  Object.entries(formik.errors).some(([key, value]) => key.startsWith('group') && formik.touched[key]);
  }
  return false;
};



    const [dialogTab, setDialogTab] = useState<number>(0)

  const [groupedActivities, setGroupedActivities] = useState<ActivityGroup[]>([]);
  const [filteredSessions, setFilteredSessions] = useState<IRecord[]>();

  useEffect(() => {
    setRows(
      registrations.map((reg) => {
        return {
          id: reg.id,
          ...reg.values,
        };
      })
    );
  }, [registrations]);

  useEffect(() => {
    const filteredActivities: SessionRecord[] = sessions.filter(
      (item: SessionRecord) => item.shownOnRegistration
    );
    const onlyActivitiesArray = filteredActivities.filter(item => item.activity);

    let groupedActivities: ActivityGroup[] = [];

    if (onlyActivitiesArray.length > 0) {
      groupedActivities = onlyActivitiesArray.reduce((acc, item) => {
        const { blockId } = item;

        if (blockId !== undefined && typeof blockId === "number") {
          const index = acc.findIndex((group) => group.blockId === blockId);

          if (index === -1) {
            if (item.block) {
              const { id, ...rest } = item.block;
              const blockInfo = { ...rest, blockId: id };
              acc.push({
                ...blockInfo,
                activities: [item],
              });
            }
          } else {
            acc[index].activities.push(item);
          }
        } else {
          const noBlockIndex = acc.findIndex((group) => group.blockId === -1);
          if (noBlockIndex === -1) {
            acc.push({
              blockId: -1,
              multiselect: false,
              activities: [item],
            });
          } else {
            acc[noBlockIndex].activities.push(item);
          }
        }
        return acc;
      }, [] as ActivityGroup[]);

      setGroupedActivities(groupedActivities);
      setFilteredSessions([
        ...filteredActivities
      ]);
    }
  }, [sessions]);

  const getFlatObj = (obj: INewRecord) => {
    var result: INewRecord = {};
    fields.forEach((field) => {
      result["field" + field.id] = obj["field" + field.id] || "";
    });

    //set is faster than includes 
    const activityIdSet = new Set(obj.activities);

    groupedActivities.forEach((groupedActivity) => {
      if (groupedActivity.blockId) {
        const key = "group" + groupedActivity.blockId;
        if (groupedActivity.multiselect) {
          const selectedActivities = groupedActivity.activities
            .filter(activity => activityIdSet.has(activity.id))
            .map(activity => activity.id);
          result[key] = selectedActivities || [];
        } else {
          const activitySelected = groupedActivity.activities.find(activity => activityIdSet.has(activity.id));
          result[key] = activitySelected ? activitySelected.id : '';
        }
      }
    });

    return result;
  };

  const buildInitialValuesAndValidationSchema = () => {
    const initialValues: InitialValues = {};
    const validationSchema: ValidationConfig<any> = {};

    fields.forEach((field) => {
      const fieldValidationSchema = {
        required: field.required,
        type: field.type,
        min: field.min,
        max: field.max,
      };
      validationSchema["field" + field.id] = buildYupStringSchema(
        fieldValidationSchema
      );
    });

    groupedActivities.forEach((groupedActivity) => {
      if (groupedActivity.blockId) {
        const fieldName = "group" + groupedActivity.blockId;
        initialValues[fieldName] = "";

        let required = (groupedActivity.activities ?? []).some(
          (activity) => activity.required
        );

        if (groupedActivity.blockId === -1) {
          required = true;
        }

        //add required config to the ablaufplan... then switch back - for now all are required to match registrationform.
        const fieldValidationSchema: ValidationTypes = {
          //required: required,
          required: true,
          type: groupedActivity.multiselect ? "multivalues" : "radio",
        };

        validationSchema[fieldName] = buildYupStringSchema(fieldValidationSchema);
      }
    });

    return { initialValues, validationSchema };
  };

  const { initialValues: builtInitialValues, validationSchema } =
    buildInitialValuesAndValidationSchema();

  const [initialValues, setInitialValues] = useState(builtInitialValues);

  const generateRegistration = (values: INewRecord) => {
    var result: INewRecord = {};
    if (id > -1) {
      result.id = id;
    }
    result.adminNote = values.adminNote;

    let copiedvalues = { ...values };


    const { registrationFieldValues, activityIds } = Object.keys(copiedvalues).reduce<{
      registrationFieldValues: Record<string, any>;
      activityIds: number[];
    }>(
      (acc, key) => {
        const value = copiedvalues[key];

        if (key.startsWith("group")) {
          // Handle activity IDs
          if (Array.isArray(value)) {
            value.forEach(v => {
              if (v !== '' && !isNaN(Number(v))) acc.activityIds.push(Number(v));
            });
          } else if (value !== '' && !isNaN(Number(value))) {
            acc.activityIds.push(Number(value));
          }
        } else {
          // other fields
          acc.registrationFieldValues[key] = value;
        }

        return acc;
      },
      { registrationFieldValues: {}, activityIds: [] }
    );

    delete copiedvalues.adminNote;

    //result.activityIds = [];
    result.activityIds = activityIds;
    result.registrationfieldValues = registrationFieldValues;
    result.eventId = eventId;
    result.widgetId = registrationWidgetId;
    result.attending = true;
    var emailfieldId = 0;
    fields.forEach((field) => {
      if (field.defaultfield === "email") {
        emailfieldId = field.id;
      }
    });
    result.email = copiedvalues["field" + emailfieldId];
    result.contact = !props.registered;
    //result.contactlistId = props.contactlistId;
    return result;
  };

  const getRegistrationShort = (registration: IRecord) => {
    const firstnameField = fields.find(
      (field) => field.defaultfield === "firstname"
    );
    const lastnameField = fields.find(
      (field) => field.defaultfield === "lastname"
    );
    const emailField = fields.find((field) => field.defaultfield === "email");

    let str = "\n\n";
    if (firstnameField) {
      str =
        str +
        firstnameField.translations[firstnameField.defaultLanguage].title +
        ": " +
        registration.values["field" + firstnameField.id] +
        "\n";
    }
    if (lastnameField) {
      str =
        str +
        lastnameField.translations[lastnameField.defaultLanguage].title +
        ": " +
        registration.values["field" + lastnameField.id] +
        "\n";
    }
    if (emailField) {
      str =
        str +
        emailField.translations[emailField.defaultLanguage].title +
        ": " +
        registration.values["field" + emailField.id] +
        "\n";
    }
    return str;
  };

  const deleteRegistration = (registration: IRecord) => {
    setConfirmtitle(translations["contacts.confirmDeleteTitle"]);
    setConfirmmessage(
      translations["contacts.confirmDeleteMessage"] +
      getRegistrationShort(registration)
    );
    setConfirmFunction(() => () => {
      setOpenConfirm(false);
      fetch("/api/registrations/" + registration.id, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("jwt"),
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((jsondata) => {
          if (jsondata.success) {
            revalidator.revalidate();
          }
        });
    });
    setOpenConfirm(true);
  };

  const formik = useFormik({
    initialValues: initialValues,
     validationSchema: Yup.object(validationSchema),
    enableReinitialize: true,
    onSubmit: (values) => {
      if (id > -1) {
        fetch("/api/registrations/" + id, {
          method: "PUT",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("jwt"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(generateRegistration(values)),
        })
          .then((res) => res.json())
          .then((jsondata) => {
            if (jsondata.success) {
              revalidator.revalidate();
            }
          })
          .finally(() => {
            formik.setSubmitting(false);
            formik.resetForm({
              values: getFlatObj(values),
            });
            setOpen(false);
          });
      } else {
        fetch("/api/registrations/manual", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("jwt"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(generateRegistration(values)),
        })
          .then((res) => res.json())
          .then((jsondata) => {
            if (jsondata.success) {
              setId(jsondata.data.id);
              revalidator.revalidate();
            }
          })
          .finally(() => {
            formik.setSubmitting(false);
            formik.resetForm({
              values: getFlatObj(values),
            });
            setOpen(false);
          });
      }
    },
  });

  let columns: (GridColDef | GridActionsColDef)[] = [
    {
      field: "id",
      headerName: translations["contacts.nofields"],
      flex: 1,
      sortable: false,
    },
  ];

  if (fields.length > 0) {
    columns = fields
      .filter(
        (field) =>
          field.type !== "divider" &&
          field.type !== "text" &&
          field.type !== "title"
      )
      .map((field) => {
        return {
          field: "field" + field.id,
          headerName: field.translations[field.defaultLanguage].title,
          flex: 1,
        };
      });
    columns.push({
      field: "actions",
      type: "actions",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          onClick={() => {
            let registration = registrations.find(
              (registration) => registration.id === params.id
            );
            if (typeof registration !== "undefined") {
              setId(registration.id);
              let obj = getFlatObj(registration.values as INewRecord);
              formik.resetForm({
                touched: {},
                errors: {},
              });
              setInitialValues(obj);
              formik.setValues(obj, false);
              setMyDialogTitle(translations["contacts.editcontacttitle"]);
              setOpen(true);
            }
          }}
          label={translations["contacts.edit"]}
        />,
        <GridActionsCellItem
          icon={<ClearIcon />}
          onClick={() => {
            let registration = registrations.find(
              (registration) => registration.id === params.id
            );
            if (typeof registration !== "undefined") {
              deleteRegistration(registration);
            }
          }}
          label={translations["contacts.delete"]}
        />,
      ],
    });
  }

  return (
    <>
      <Box p={1} gap={1} display="flex" flexDirection="row">
        <ContactImportControl
          registered={props.registered}
          onUploadComplete={() => {
            revalidator.revalidate();
          }}
          eventId={eventId}
          registrationFields={fields.filter(
            (field) =>
              field.type !== "divider" &&
              field.type !== "text" &&
              field.type !== "title"
          )}
        />
        <Button
          variant="contained"
          onClick={() => {
            setId(-1);
            let obj = getFlatObj({});
            formik.resetForm({
              values: obj,
              touched: {},
              errors: {},
            });
            setInitialValues(obj);
            formik.setValues(obj);
            setMyDialogTitle(translations["contacts.newcontacttitle"]);
            setOpen(true);
          }}
        >
          {translations["contacts.add"]}
        </Button>
      </Box>
      <DataGrid
        rowCount={rowCountState}
        rows={rows}
        columns={columns}
        localeText={gridtranslations}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={(m) => {
          console.log(m);
        }}
      ></DataGrid>
      <Dialog
        className="window"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        scroll="body"
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle>{myDialogTitle}</DialogTitle>
        <DialogContent dividers={false}>
          {sessions.length > 0 ? (
                      <>
                        <Tabs
                          value={dialogTab}
                          onChange={(e, newValue) => setDialogTab(newValue)}
                          sx={{ mb: 2 }}
                        >
                          <Tab label={translations["registrations.general"]} sx={{ color: tabHasError(0) ? "error.main" : "inherit" }}/>
                          <Tab label={translations['registrations.sessions']} sx={{ color: tabHasError(1) ? "error.main" : "inherit" }}/>
                        </Tabs>
                        <form>
                          {dialogTab === 0 && (
                            <Box display="flex" flexDirection="column">
                              {fields.map((value) => (
                                <Registrationfield
                                  field={value}
                                  formik={formik}
                                  key={value.id}
                                />
                              ))}
                              <Box key={"adminNote"}>
                                <Box className="fieldlabel">
                                  <Typography>{translations["contacts.adminNote"]}</Typography>
                                </Box>
                                <FormControl fullWidth>
                                  <TextField
                                    size="small"
                                    multiline={true}
                                    minRows={3}
                                    {...formik.getFieldProps("adminNote")}
                                  ></TextField>
                                </FormControl>
                              </Box>
                            </Box>
                          )}
                          {dialogTab === 1 && (
                            <Box display="flex" flexDirection="column">
                              <Grid container mb={"1rem"}>
                                {groupedActivities &&
                                  groupedActivities.map((activityGroup, index) => {
          
                                    const matchingBlock = blocks.find(
                                      (block) => block.id === activityGroup.blockId,
                                    );
          
                                    const blockTitle =
                                      activityGroup.blockId === -1
                                        ? translations['registrations.loose']
                                        : matchingBlock?.translations?.de?.title ?? '';
          
                                    const blockMultiSelect = matchingBlock
                                      ? matchingBlock.multiselect
                                      : false;
          
                                    let options = activityGroup.activities.map((activity) => ({
                                      value: activity.id.toString(),
                                      label: activity.translations.de.title,
                                      description: activity.translations.de.shortDescription,
                                    }))
          
                                    let formikId = "group" + activityGroup.blockId;
                                    const error = formik.touched?.[formikId] && formik.errors?.[formikId];
          
                                    if (activityGroup.blockId) {
                                      return (
                                        <Grid item xs={12} key={index}>
                                          <Box display="flex" flexDirection="row" key={activityGroup.blockId} mb={1}>
                                            <Box className="fieldlabel" minWidth={"300px"} maxWidth={"300px"}>
                                              <Typography>
                                                {blockTitle}
                                              </Typography>
                                            </Box>
                                            <Box>
                                              <FormControl fullWidth error={!!error} size="small">
                                                {blockMultiSelect ? (
                                                  <FormGroup
                                                    sx={{ flexDirection: "column" }}
                                                  >
                                                    {options.map((option, index) => {
                                                      const checked = formik.values[formikId]?.includes(Number(option.value));
                                                      return (
                                                        <FormControlLabel
                                                          key={index}
                                                          sx={{ marginBottom: "1rem" }}
                                                          control={
                                                            <Checkbox
                                                              name={formikId}
                                                              checked={checked}
                                                              onChange={(e) => {
                                                                const currentValues = formik.values[formikId] || [];
                                                                if (e.target.checked) {
                                                                  formik.setFieldValue(formikId, [
                                                                    ...currentValues,
                                                                    Number(option.value),
                                                                  ]);
                                                                } else {
                                                                  formik.setFieldValue(
                                                                    formikId,
                                                                    currentValues.filter(
                                                                      (v: number) => v !== Number(option.value)
                                                                    )
                                                                  );
                                                                }
                                                              }}
                                                            />
                                                          }
                                                          value={option.value}
                                                          label={
                                                            <div>
                                                              <div>{option.label}</div>
                                                              {option.description && (
                                                                <div
                                                                  style={{
                                                                    fontSize: "0.85rem",
                                                                    color: "#666",
                                                                    marginTop: 0,
                                                                  }}
                                                                >
                                                                  {option.description}
                                                                </div>
                                                              )}
                                                            </div>
                                                          }
                                                        />
                                                      );
                                                    })}
                                                  </FormGroup>
                                                )
                                                  : (
                                                    <RadioGroup onChange={(e) => {
                                                      formik.setFieldValue("group" + activityGroup.blockId, e.target.value);
                                                    }} row value={formik.values[formikId]} sx={{ flexDirection: "column" }}>
                                                      {options.map((option, index) => {
                                                        return (
                                                          <FormControlLabel
                                                            control={<Radio />}
                                                            key={index}
                                                            value={option.value}
                                                            sx={{ display: "block" }}
                                                            label={
                                                              <span>
                                                                {option.label}
                                                              </span>
                                                            }
                                                          />
                                                        );
                                                      })}
                                                    </RadioGroup>
                                                  )}
                                                {error && (
                                                  <FormHelperText color="error">
                                                    {typeof error === "string" ? error : null}
                                                  </FormHelperText>
                                                )}
          
                                              </FormControl>
                                            </Box>
                                          </Box>
                                        </Grid>
                                      );
                                    }
                                  })}
                              </Grid>
                            </Box>
                          )
                          }
          
                        </form>
                      </>
                    ) : (
          <form>
            <Box display="flex" flexDirection="column">
              {fields.map((value) => (
                <Registrationfield
                  field={value}
                  formik={formik}
                  key={value.id}
                />
              ))}
            </Box>
          </form>)}
        </DialogContent>
        <SaveBar
          formik={formik}
          manualSubmit={true}
          onCancel={() => {
            setOpen(false);
          }}
        ></SaveBar>
      </Dialog>
      <Dialog
        className="window"
        open={openConfirm}
        onClose={() => {
          setOpenConfirm(false);
        }}
        scroll="body"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle>{confirmtitle}</DialogTitle>
        <DialogContent dividers={false}>
          <DialogContentText style={{ whiteSpace: "pre-line" }}>
            {confirmmessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              confirmFunction();
            }}
          >
            {translations["contacts.confirm"]}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenConfirm(false);
            }}
          >
            {translations["contacts.cancel"]}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ImportedContacts;
